<template>
  <validation-observer
    ref="observer"
    tag="form">
    <div v-if="editAddress" v-element-loader="{ endpoint: 'auth/updateAddress' }" class="address-inputs">
      <oie-address-component id="checkout" :address="editAddress"></oie-address-component>

      <div class="address-inputs__actions">
        <oie-base-button
          css-classes="button--with-border button--blue"
          :text="t('deliveryAddressSaveButtonLabel')"
          @click="updateAddress()">
        </oie-base-button>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import httpService from '@/core/http-service'
import _ from 'lodash'
export default {
  props: {
    address: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: () => ({
    customer: Object,
    countryList: null,
    editAddress: {}
  }),
  watch: {
    address(value) {
      this.editAddress = { ...value }
    }
  },
  mounted() {
    this.editAddress = { ...this.address }
    httpService.get('auth/get').then(response => {
      this.customer = response.data
    })
  },
  methods: {
    updateAddress() {
      this.$refs.observer.validate().then((valid) => {
        if(valid) {
          httpService.post('auth/updateAddress', {
            ...this.editAddress,
            isShippingAddress: true
          })
            .then((response) => {
              _.merge(this.address, this.editAddress)
              this.$emit('done')
            })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.address-inputs {
  width: 100%;
}

.address-inputs > *:not(:last-child) {
  margin-bottom: measure(half);
}

.address-inputs__actions {
  display: flex;
  align-items: center;
}

.adress-inputs__cancel {
  @include reset-button;
  height: 2.5rem;
  margin-left: measure(quarter);
  padding: 0 measure(quarter);
}
</style>
